/* eslint-disable @typescript-eslint/no-explicit-any */
import * as React from "react";
import { useTranslation } from "react-i18next";
import { CoreRouter } from "./CoreRouter";
export function CoreBootloader(): JSX.Element {
  useTranslation();
  return <CoreRouter />;
}